import { LAYOUTS, } from "@voltmoney/types";
import { ButtonTypeTokens, ButtonWidthTypeToken, ColorTokens, FontFamilyTokens, FontSizeTokens, IconSizeTokens, IconTokens, InputStateToken, InputTypeToken, KeyboardTypeToken, SizeTypeTokens, StackAlignItems, StackJustifyContent, StackType, WIDGET, } from "@voltmoney/schema";
import { ROUTE } from "../../../routes";
import { ACTION } from "./types";
import { EditAmountAction, goBack, ModifyAmountAction } from "./actions";
import { getActualLimit } from "../portfolio/actions";
import { roundDownToNearestHundred } from "../../../configs/utils";
import { heightMap } from "../../../configs/height";
import { Platform } from "react-native";
import { isDarkModeTheme } from "../../../configs/config";
let isDarkMode = isDarkModeTheme();
export const template = (index, stepResponseObject, selectedMap, portfolioSearchKeyword) => {
    return {
        layout: {
            id: ROUTE.MODIFY_PLEDGED_AMOUNT,
            type: LAYOUTS.MODAL,
            style: {
                height: heightMap[ROUTE.MODIFY_PLEDGED_AMOUNT]
            },
            widgets: [
                {
                    id: "headerStack",
                    type: WIDGET.STACK,
                },
                { id: "titleSpace", type: WIDGET.SPACE },
                { id: "subTitle", type: WIDGET.TEXT },
                { id: "subTitleSpace", type: WIDGET.SPACE },
                { id: "input", type: WIDGET.INPUT },
                { id: "inputSpace", type: WIDGET.SPACE },
                { id: "bottomStack", type: WIDGET.STACK }
            ],
        },
        datastore: {
            headerStack: {
                type: StackType.row,
                alignItems: StackAlignItems.center,
                justifyContent: StackJustifyContent.flexEnd,
                widgetItems: [{ id: "trailIcon", type: WIDGET.ICON }],
            },
            trailIcon: {
                name: IconTokens.Cancel,
                size: IconSizeTokens.XXXXL,
                color: ColorTokens.Grey_Night,
                action: {
                    type: ACTION.GO_BACK,
                    routeId: ROUTE.MODIFY_PLEDGED_AMOUNT,
                },
            },
            titleSpace: { size: SizeTypeTokens.MD },
            subTitle: {
                label: stepResponseObject.availableCAS[index].schemeName,
                fontSize: FontSizeTokens.LG,
                color: isDarkMode ? ColorTokens.White : ColorTokens.Grey_Night,
                fontFamily: FontFamilyTokens.Inter,
                fontWeight: "400",
            },
            subTitleSpace: { size: SizeTypeTokens.XXXL },
            input: {
                id: 'tf_setCreditLimit_enterAmount',
                type: InputTypeToken.DEFAULT,
                state: InputStateToken.DEFAULT,
                isDarkMode: isDarkMode ? true : false,
                placeholder: "",
                title: "Enter amount",
                onlyNumeric: true,
                limit: getActualLimit([stepResponseObject.availableCAS[index]], stepResponseObject.isinNAVMap, stepResponseObject.isinLTVMap),
                limitLabel: "out of ₹ " +
                    `${roundDownToNearestHundred(getActualLimit([stepResponseObject.availableCAS[index]], stepResponseObject.isinNAVMap, stepResponseObject.isinLTVMap))}`.replace(/\B(?=(?:(\d\d)+(\d)(?!\d))+(?!\d))/g, ","),
                caption: { success: "", error: "" },
                keyboardType: KeyboardTypeToken.numberPad,
                action: {
                    type: ACTION.EDIT_AMOUNT,
                    payload: { value: "" },
                    routeId: ROUTE.MODIFY_PLEDGED_AMOUNT,
                },
            },
            spaceLG: {
                size: SizeTypeTokens.XL
            },
            inputSpace: { size: SizeTypeTokens.XXXL },
            continue: {
                id: 'bt_setCreditLimit_updateAmount',
                label: "Update amount",
                fontSize: FontSizeTokens.SM,
                fontFamily: FontFamilyTokens.Inter,
                type: ButtonTypeTokens.LargeFilled,
                width: ButtonWidthTypeToken.FULL,
                action: {
                    type: ACTION.MODIFY_PLEDGED_AMOUNT,
                    payload: {
                        index,
                        stepResponseObject,
                        selectedMap,
                        portfolioSearchKeyword,
                    },
                    routeId: ROUTE.MODIFY_PLEDGED_AMOUNT,
                },
            },
            bottomStack: {
                type: StackType.column,
                bgColor: isDarkMode ? ColorTokens.DARK_MODE : ColorTokens.White,
                padding: {
                    bottom: Platform.OS === "ios" ? SizeTypeTokens.XXXXXXL : SizeTypeTokens.NONE
                },
                widgetItems: [
                    { id: "continue", type: WIDGET.BUTTON },
                    { id: "spaceXL", type: WIDGET.SPACE },
                    Platform.OS === "ios" ? { id: "spaceXL", type: WIDGET.SPACE } : {}
                ]
            }
        },
    };
};
export const modifyPledgeMF = {
    onLoad: async (_, { index, stepResponseObject, selectedMap, portfolioSearchKeyword }) => {
        return Promise.resolve(template(index, stepResponseObject, selectedMap, portfolioSearchKeyword));
    },
    actions: {
        [ACTION.MODIFY_PLEDGED_AMOUNT]: ModifyAmountAction,
        [ACTION.EDIT_AMOUNT]: EditAmountAction,
        [ACTION.GO_BACK]: goBack,
    },
    clearPrevious: true,
};
